import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-28de48ac"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "color_999"
}, " 提示：默认密码A123456 ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Resource = _resolveComponent("Resource");
  const _component_OrganizeSelect = _resolveComponent("OrganizeSelect");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_input = _resolveComponent("el-input");
  const _component_AreaSelect = _resolveComponent("AreaSelect");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_form = _resolveComponent("el-form");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["submitForm", {
      heightFrom: _ctx.formData.isCreateSchool
    }])
  }, [_createVNode(_component_Resource, {
    visible: _ctx.resourceVisible,
    "onUpdate:visible": _cache[0] || (_cache[0] = $event => _ctx.resourceVisible = $event),
    ref: "resourceRef",
    orgId: _ctx.roleOrgId,
    onHandleSuccess: _ctx.getRole
  }, null, 8, ["visible", "orgId", "onHandleSuccess"]), _createVNode(_component_el_form, {
    ref: "ruleForm",
    rules: _ctx.rules,
    model: _ctx.formData,
    "label-width": "110px"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_form_item, {
      label: "上级组织",
      prop: "parentId"
    }, {
      default: _withCtx(() => [_createVNode(_component_OrganizeSelect, {
        modelValue: _ctx.searchValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.searchValue = $event),
        id: _ctx.formData.parentId,
        activeValue: _ctx.activeValue,
        isClick: false,
        isSpecify: 'org',
        isDoubleClick: true,
        placeholder: '请选择组织',
        onHandleDoubleClick: _ctx.handleDoubleClick
      }, null, 8, ["modelValue", "id", "activeValue", "onHandleDoubleClick"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "组织名称",
      prop: "name"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: _ctx.formData.name,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.formData.name = $event),
        placeholder: "请输入组织名称",
        onInput: _cache[3] || (_cache[3] = val => _ctx.formData.loginName = val)
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "所属区域"
    }, {
      default: _withCtx(() => [_createVNode(_component_AreaSelect, {
        style: {
          "width": "100%"
        },
        placeholder: "请选择所属行政区域",
        inputValue: _ctx.selectAreaValue,
        "onUpdate:inputValue": _cache[4] || (_cache[4] = $event => _ctx.selectAreaValue = $event),
        onHandleChange: _ctx.handleSelectArea
      }, null, 8, ["inputValue", "onHandleChange"])]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "登录账号",
      prop: "loginName",
      required: false
    }, {
      default: _withCtx(() => [_createVNode(_component_el_input, {
        modelValue: _ctx.formData.loginName,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _ctx.formData.loginName = $event),
        placeholder: "不填写默认组织名称"
      }, null, 8, ["modelValue"]), _hoisted_1]),
      _: 1
    }), _createVNode(_component_el_form_item, {
      label: "登录权限",
      prop: "roleId",
      required: false
    }, {
      default: _withCtx(() => [_createVNode(_component_el_select, {
        class: "w_100 margin_bottom",
        modelValue: _ctx.formData.roleId,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.formData.roleId = $event)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roleType, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.value,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[7] || (_cache[7] = $event => _ctx.visibleChange(_ctx.formData.id, _ctx.formData.roleId))
      }, {
        default: _withCtx(() => [_createTextVNode("查看权限")]),
        _: 1
      })]),
      _: 1
    })]),
    _: 1
  }, 8, ["rules", "model"])], 2);
}